import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-aggregation-type',
  templateUrl: './custom-sources-badge-aggregation-type.component.html',
  styleUrls: ['./custom-sources-badge-aggregation-type.component.scss']
})
export class CustomSourcesBadgeAggregationTypeComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
